export const GOOGLE_MAPS_API_KEY = "AIzaSyBsm3eUda_4l2IX1j4UwSeUbdNpYce0f2o";